import {
  successColor,
  tooltip,
  cardTitle,
  grayColor,
} from "../../assets/jss/material-dashboard-pro-react.jsx";

import hoverCardStyle from "../../assets/jss/material-dashboard-pro-react/hoverCardStyle.jsx";

const dashboardStyle = (theme) => ({
  ...hoverCardStyle,
  tooltip,
  cardTitle: {
    ...cardTitle,
    marginTop: "0px",
    marginBottom: "3px",
    fontFamily: "Roboto-Light",
    color: "#3C4858",
    fontSize: "39px",
    fontWeight: "bolder",
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
  cardProductTitle: {
    ...cardTitle,
    marginTop: "0px",
    marginBottom: "3px",
    textAlign: "center",
  },
  cardCategory: {
    fontWeight: "bold",
    fontSize: "18px",
    paddingTop: "10px",
    marginBottom: "0",
    marginTop: "-39px",
    margin: "0",
    marginLeft: "30%",
    fontFamily: "Roboto-Light",
    color: "#999999",
  },
  cardProductDesciprion: {
    textAlign: "center",
    color: grayColor[0],
  },
  stats: {
    color: grayColor[0],
    fontSize: "12px",
    lineHeight: "22px",
    display: "inline-flex",
    "& svg": {
      position: "relative",
      top: "4px",
      width: "16px",
      height: "16px",
      marginRight: "3px",
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      position: "relative",
      top: "4px",
      fontSize: "16px",
      marginRight: "3px",
    },
  },
  productStats: {
    paddingTop: "7px",
    paddingBottom: "7px",
    margin: "0",
  },
  successText: {
    color: successColor[0],
  },
  upArrowCardCategory: {
    width: 14,
    height: 14,
  },
  underChartIcons: {
    width: "17px",
    height: "17px",
  },
  price: {
    color: "inherit",
    "& h4": {
      marginBottom: "0px",
      marginTop: "0px",
    },
  },
  card: {
    width: "135%",
    height: "80%",
    [theme.breakpoints.down("md")]: {
      width: "99%",
    },
    [theme.breakpoints.between("sm", "md")]: {
      width: "99%",
    },
  },
  card1: {
    width: "135%",
    height: "80%",
    marginLeft: "32%",
    [theme.breakpoints.down("md")]: {
      width: "99%",
      marginLeft: "-4%",
    },
    [theme.breakpoints.only("sm")]: {
      marginLeft: "0%",
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0%",
    },
  },
  card2: {
    width: "135%",
    height: "80%",
    marginLeft: "65%",
    [theme.breakpoints.down("md")]: {
      width: "99%",
      marginLeft: "-8%",
    },
    [theme.breakpoints.only("sm")]: {
      marginLeft: "0%",
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0%",
    },
  },
  icon: {
    [theme.breakpoints.down("md")]: {
      padding: "1px",
    },
  },
});

export default dashboardStyle;
